import { ADMIN_CODE_FORM } from './index';
import { Action } from '../action';
import { AccessCodeInfo } from '@shared/core';

export class AdminCodeFormInitAction implements Action {
	readonly type = ADMIN_CODE_FORM.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminCodeFormDestroyAction implements Action {
	readonly type = ADMIN_CODE_FORM.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminCodeFormClickAddOrganizationAction implements Action {
	readonly type = ADMIN_CODE_FORM.CLICK_ADD_ORGANIZATION;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminCodeFormClickAddGroupAction implements Action {
	readonly type = ADMIN_CODE_FORM.CLICK_ADD_GROUP;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminCodeFormSelectOrganizationCodeAction implements Action {
	readonly type = ADMIN_CODE_FORM.SELECT_ORGANIZATION_CODE;
	constructor(
		public payload: string,
		public correlationId?: number
	) {}
}

export class AdminCodeFormSelectGroupCodeAction implements Action {
	readonly type = ADMIN_CODE_FORM.SELECT_GROUP_CODE;
	constructor(
		public payload: string,
		public correlationId?: number
	) {}
}

export class AdminCodeFormClickSubmitAction implements Action {
	readonly type = ADMIN_CODE_FORM.CLICK_SUBMIT;
	constructor(
		public payload: AccessCodeInfo,
		public correlationId?: number
	) {}
}

export class AdminCodeFormUpdateAction implements Action {
	readonly type = ADMIN_CODE_FORM.UPDATE;
	constructor(
		public payload: AccessCodeInfo,
		public correlationId?: number
	) {}
}

export class AdminCodeFormUpdateSuccessAction implements Action {
	readonly type = ADMIN_CODE_FORM.UPDATE_SUCCESS;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminCodeFormUpdateFailureAction implements Action {
	readonly type = ADMIN_CODE_FORM.UPDATE_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AdminCodeFormAddAction implements Action {
	readonly type = ADMIN_CODE_FORM.ADD;
	constructor(
		public payload: AccessCodeInfo,
		public correlationId?: number
	) {}
}

export class AdminCodeFormAddSuccessAction implements Action {
	readonly type = ADMIN_CODE_FORM.ADD_SUCCESS;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminCodeFormAddFailureAction implements Action {
	readonly type = ADMIN_CODE_FORM.ADD_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}
